import React from 'react';
import getAccumulatedCompletionTime from 'utils/asset/getAccumulatedCompletionTime';
import SectionContentInfo from 'components/PlaylistContentTree/Section/SectionContentInfo';
import { getAllContentChildren } from '../utils/getAllContentChildren';
import { useLockingInfoText } from 'components/PlaylistContentTree/Section/utils/useLockingInfoText';
import { jsx as _jsx } from "react/jsx-runtime";
export function EditableSectionContentInfo(_ref) {
  var section = _ref.section;
  var sectionContent = getAllContentChildren(section.children);
  return /*#__PURE__*/_jsx(SectionContentInfo, {
    withLockIcon: true,
    lockingInfoText: useLockingInfoText({
      section: section,
      context: 'manager'
    }),
    contentItemCount: sectionContent.length,
    sectionDuration: getAccumulatedCompletionTime(sectionContent)
  });
}